import { UserPlus, Cake, Clock, Heart, UserX, Tag } from 'lucide-react';

/** Un unico elenco di tipologie: ogni voce tiene insieme l'automazione interna,
 *  l'invio automatico su WhatsApp e la campagna manuale corrispondente. */
export const TRIGGERS = [
  {
    id: 'welcome', label: 'Benvenuto', presetId: 'welcome', autoKey: 'welcome_enabled',
    icon: UserPlus, color: 'text-emerald-500', bg: 'bg-emerald-500/10',
    description: 'Parte quando registri un nuovo cliente.',
    autoTitle: 'Saluta ogni nuovo cliente',
    autoDescription: 'Appena lo registri riceve il messaggio di benvenuto su WhatsApp.',
    template: 'Ciao {nome}! Benvenuto/a nel nostro salone. Siamo felici di averti tra i nostri clienti. Per qualsiasi esigenza non esitare a contattarci!',
  },
  {
    id: 'birthday', label: 'Compleanno', presetId: 'birthday', autoKey: 'birthday_enabled',
    icon: Cake, color: 'text-pink-500', bg: 'bg-pink-500/10',
    description: 'Auguri il giorno del compleanno.',
    autoTitle: 'Fai gli auguri da solo',
    autoDescription: 'Ogni mattina tra le 8 e le 10 parte su WhatsApp l\'augurio a chi compie gli anni.',
    template: 'Buon compleanno {nome}! Per festeggiare insieme, ti offriamo uno sconto del 15% su tutti i servizi per tutta la settimana. Ti aspettiamo!',
  },
  {
    id: 'appointment_reminder', label: 'Promemoria appuntamenti', presetId: 'reminder', autoKey: 'reminder_enabled',
    icon: Clock, color: 'text-blue-500', bg: 'bg-blue-500/10',
    description: 'Ricorda l\'appuntamento prima che arrivi.',
    autoTitle: 'Ricorda l\'appuntamento',
    autoDescription: 'Il promemoria WhatsApp parte 24 ore prima di ogni appuntamento in agenda.',
    template: 'Ciao {nome}, ti ricordiamo il tuo appuntamento per {servizio} in programma il {data} alle {ora}. Ti aspettiamo!',
  },
  {
    id: 'post_appointment', label: 'Follow-up post-appuntamento', presetId: 'follow_up', autoKey: 'follow_up_enabled',
    icon: Heart, color: 'text-purple-500', bg: 'bg-purple-500/10',
    description: 'Messaggio dopo il servizio, per esempio per la recensione.',
    autoTitle: 'Chiedi la recensione',
    autoDescription: 'Ventiquattro ore dopo l\'appuntamento parte su WhatsApp l\'invito a lasciare una recensione.',
    template: 'Ciao {nome}! Speriamo che il tuo {servizio} ti sia piaciuto. Se hai un momento, lasciaci una recensione qui: {recensione}\n\nGrazie di cuore!',
  },
  {
    id: 'inactive_client', label: 'Cliente inattivo', presetId: 'inactive', autoKey: null,
    icon: UserX, color: 'text-amber-500', bg: 'bg-amber-500/10',
    description: 'Richiama chi non prenota da tempo.',
    template: 'Ciao {nome}, ci manchi! Non ti vediamo da un po\'. Che ne dici di un nuovo appuntamento? Abbiamo tante novità che ti aspettano!',
  },
  {
    id: 'promotional', label: 'Promozione', presetId: 'promo', autoKey: null,
    icon: Tag, color: 'text-red-500', bg: 'bg-red-500/10',
    description: 'Offerta programmata: una volta sola oppure ogni settimana o mese.',
    template: 'Ciao {nome}! Questa settimana abbiamo un\'offerta speciale per te: scopri le nostre promozioni in salone. Ti aspettiamo!',
  },
];

export const CHANNELS = [
  { id: 'whatsapp', label: 'WhatsApp', color: 'text-green-600' },
  { id: 'email', label: 'Email', color: 'text-blue-600' },
  { id: 'sms', label: 'SMS', color: 'text-violet-600' },
];

export const PLACEHOLDERS = [
  { tag: '{nome}', desc: 'Nome del cliente' },
  { tag: '{cognome}', desc: 'Cognome del cliente' },
  { tag: '{servizio}', desc: 'Nome del servizio' },
  { tag: '{data}', desc: 'Data appuntamento' },
  { tag: '{ora}', desc: 'Ora appuntamento' },
  { tag: '{salone}', desc: 'Nome del salone' },
  { tag: '{recensione}', desc: 'Link per lasciare la recensione su Google' },
];

export const REPEAT_OPTIONS = [
  { id: 'once', label: 'Una volta sola' },
  { id: 'weekly', label: 'Ogni settimana' },
  { id: 'monthly', label: 'Ogni mese' },
];

export const FILTER_LABELS = {
  all: 'Tutti i clienti',
  new_30d: 'Nuovi clienti (ultimi 30 giorni)',
  vip: 'Clienti VIP',
  service: 'Clienti di un servizio',
  recent_30d: 'Recenti (ultimi 30 giorni)',
  inactive_60d: 'Inattivi (60+ giorni)',
  inactive_90d: 'Inattivi (90+ giorni)',
  birthday_today: 'Compleanno di oggi',
  upcoming_appointments: 'Con appuntamento nelle prossime 48h',
  completed_yesterday: 'Appuntamento di ieri',
};

export const FILTER_OPTIONS_BY_CAMPAIGN = {
  welcome: ['new_30d', 'all'],
  reminder: ['upcoming_appointments'],
  inactive: ['inactive_90d', 'inactive_60d', 'vip'],
  birthday: ['birthday_today'],
  follow_up: ['completed_yesterday'],
  promo: ['all', 'vip', 'service', 'recent_30d', 'inactive_60d'],
};

/** Spiegazione dei gruppi che non si capiscono dal nome. */
export const FILTER_HINTS = {
  vip: 'Sono VIP i clienti con la spunta VIP nella scheda cliente o con almeno 5 appuntamenti.',
  service: 'Prende chi ha quel servizio tra i Servizi Abituali e chi lo ha prenotato almeno una volta.',
};
